module.exports = require('./helpers/bundle-url').getBundleURL('4e6ko') + "logo.c51670a8.svg";